import { state as mdmState } from '@/store/modules/mdm/state';

export const patientRegistration = [
  {
    path: '/cadastro-paciente',
    name: 'patient-registry',
    component: () => import('@/views/PatientRegistry.view.vue'),
    beforeEnter: (to, from, next) => {
      mdmState.data.id ? to.meta.header.title = 'Confirme seus dados' : to.meta.header.title = 'Cadastro';
      next();
    },
    meta: {
      header: {
        title: '',
      },
    },
  },

  {
    path: '/cadastro-paciente',
    name: 'patient-registry-public',
    component: () => import('@/views/PatientRegistry.view.vue'),
    beforeEnter: (to, from, next) => {
      mdmState.data.id ? to.meta.header.title = 'Confirme seus dados' : to.meta.header.title = 'Cadastro';
      next();
    },
    meta: {
      publicRoute: true,
      disabledPageReloadGuard: true,
      header: {
        title: '',
      },
    },
  },
];
